module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pagination-partial"
  }, [_c('div', {
    staticClass: "index"
  }, [_c('p', {
    staticClass: "total"
  }, [_vm._v("\n      " + _vm._s(_vm._f("numberize")(_vm.total)) + "\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }), _vm._v(" "), _c('p', {
    staticClass: "current"
  }, [_vm._v("\n      " + _vm._s(_vm._f("numberize")(_vm.current + 1)) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "arrows"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.current !== 0),
      expression: "current !== 0"
    }],
    on: {
      "click": _vm.prev
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-left"
  })]), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.current + 1 < _vm.total),
      expression: " current + 1 < total"
    }],
    on: {
      "click": _vm.next
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-right"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24c8dd29"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/epigram/Pagination.vue
// module id = 93
// module chunks = 0